<template>
  <v-container>
    <TaxrollCriteria
      :baseCrudKey="baseCrudKey"
      :feeListBasedInIds="feeListBasedInIds"
      @loadCRUDList="handleLoadTIRoll"
      @setDefaultSelectedItems="setDefaultSelectedItems"
      @onPenaltyDateChange="onPenaltyDateChange"
    />
    <PayrixPaymentDialog
      v-if="isPayrixDialogOpen"
      :fieldNameLists="fieldNameListsForPayrixDialog"
    />
    <Forte2PaymentDialog
      v-if="isForte2DialogOpen"
      :fieldNameLists="fieldNameListsForForte2Dialog"
    />
    <template>
      <CRUDList
        ref="crudList"
        tableDynamicHeight="280"
        tableDynamicClassname="taxroll-custom-table"
        tableWrapperDynamicClassname="elevation-3 mt-4 ma-3 pt-0 pa-1 taxroll-table-wrapper"
        :dialogDynamicWidth="wideDialogWidth"
        :dialogDynamicHeight="wideDialogHeight"
        :canAdd="false"
        :canEdit="true"
        :canSave="false"
        :canCancel="false"
        :closeOnEnter="false"
        :enableFixedHeaders="true"
        :displayTopPagination="false"
        :removeHighlightOnDoubleClick="false"
        :headers="dynamicHeaders"
        :tabsList="visibleTabsList"
        :baseCrudKey="baseCrudKey"
        :defaultSortBy="defaultSortBy"
        :formatPidPositions="formatPidPositions"
        :loadingData="gridLoading.flag"
        :loadingText="gridLoading.text"
        :variableToChangeRowBgColor="getTaxRecordHighlightColors"
        @loadCRUDList="handleLoadTIRoll"
        @onSingleClicked="handleSingleOrArrowClick"
        @onDoubleClicked="handleDoubleClick"
        @onArrowUpOrDown="handleSingleOrArrowClick"
        @activateItem="activateTransaction"
        @crudDialogClose="crudDialogClose"
        @crudDialogEnter="saveOnEnter"
        :uploadFileParams="uploadFileParams"
        :footerTotalDisplayColumnWise="showTotalDue"
        >
      <template v-slot:addidtionalCrudFooter>
        <CommonActionButtons v-if="canActOnTaxRecord" :selectedRowData="selectedRowData"
          :fromTaxRollSearch="true" ref="commonActionRef"
          :baseCrudKey="baseCrudKey"
          @onBrowseBidClicked="handleLoadTIRoll"
          @emitPaymentDialog="handlePaymentDialogClick"
          @setDefaultSelectedItems="setDefaultSelectedItems"
          @callTheArrowDownShortCut="callTheArrowDownShortCut" />
      </template>
        <template v-slot:[`editedItem`]="{}">
          <TaxInquiryDialog
            v-if="isDialogVisible"
            :baseCrudKey="baseCrudKey"
            :baseCrudKeyForFeeList="baseCrudKeyForFeeList"
            :feeListBasedInIds="feeListBasedInIds"
            :attachmentConstants="attachmentConstants"
            @loadCRUDList="handleLoadTIRoll"
            @upsertItem="upsertRecords"
            @delinquentRefresh="refreshDelinquentRecords"
          />
        </template>
        <template v-slot:[`additionalActions`]="{}">
          <!-- SMS / Print Statement / Email Statement / Info Sheet / Add to List / Pay Now /
               Upload / Audit History: all gone for the sterilised view-only persona. -->
          <span v-if="getUpdatedTabVal === 0 && canActOnTaxRecord">
            <v-row>
              <v-btn class="input-text-size" text color="blue darken-1"
            @click="handleSMSDialog">SMS</v-btn>
              <v-btn
                class="input-text-size"
                text
                color="blue darken-1"
                @click="printStatement"
                >Print Statement</v-btn
              >
              <v-btn class="input-text-size" text color="blue darken-1"
               @click="handleEmailStatement"
                >Email Statement</v-btn
              >

              <v-btn class="input-text-size" text color="blue darken-1"
               @click="printInfoSheet"
                >info sheet</v-btn
              >

              <v-btn
                class="input-text-size tax-roll-transaction-list-add-to-list-btn"
                id="taxRollTransactionListAddToListBtn"
                text
                color="blue darken-1"
                @click="addToList"
              >
                Add to List
              </v-btn>
              <v-btn
                class="input-text-size tax-roll-transaction-list-pay-now-btn"
                id="taxRollTransactionListPayNowBtn"
                text
                color="blue darken-1"
                @click="handlePaymentDialogClick"
              >
                Pay Now
              </v-btn>
              <UploadFile
                class="mtgtrans uploadFile"
                text
                :bucketName="attachmentConstants.bucketName"
                :program="attachmentConstants.program"
                :parentObjectType="attachmentConstants.parentObjectType"
                :parentObjectId="getActiveTransID || ''"
                :itemIsSaved="!isNewItem"
              >
                <template v-slot:activator="{ activatorProps }">
                  <v-btn
                    class="input-text-size"
                    text
                    color="blue darken-1"
                    @contextmenu.prevent="imagesRightClick(activatorProps.rightClick)"
                    @click="imagesLeftClick(activatorProps.leftClick)"
                  >
                    {{ activatorProps.caption }}
                  </v-btn>
                </template>
              </UploadFile>
              <AuditDialog
                v-if="getActiveTransID"
                :identifier="getActiveTransID"
                activatorCaption="Audit History"
                activatorCaptionStyle="input-text-size"
              />
            </v-row>
          </span>
        </template>
    <template v-slot:[`additionalActionsAfterSave`]="{}">
      <v-btn
        class="input-text-size tax-roll-transaction-list-save-btn"
        id="taxRollTransactionListSaveBtn"
        text
        color="blue darken-1"
        v-if="!areTheyAreForms() && canActOnTaxRecord"
        @click="upsertRecords(false)"
      >
        Save
      </v-btn>
      <!-- With no Save there is nothing to cancel, so the button reads Close; it has to stay,
           it is the only way out of the dialog. -->
      <v-btn
        class="input-text-size tax-roll-transaction-list-cancel-close-btn"
        id="taxRollTransactionListCancelCloseBtn"
        text
        color="blue darken-1"
        @click="closeDialog"
      >
        {{ !areTheyAreForms() && canActOnTaxRecord ? 'Cancel' : 'Close' }}
      </v-btn>
    </template>
      </CRUDList>
    </template>
    <TaxRollFooter
      :selectedRowData="selectedRowData"
      @onRightClicked="handleDoubleClick"
      :baseCrudKey="baseCrudKey"
      @addNewComments="addNewComments"
    />
    <CommonPaymentDialog ref="commonPayment" :baseCrudKey="paymentCrudKey"
    :fromCompBaseCrudKey="baseCrudKey" @upsertFuncCall="upsertFuncCall" />
      <!-- dialog for address update -->
      <CRUDDialog
        :baseCrudKey='emailStatementCrudKey'
        :canSave="true"
        :onlyDialogHeaderName="emailStatementHeader"
        @upsertItem="handleEmail"
        dialogDynamicWidth='550'
        canSaveCustomLabel="Send"
      ><template v-slot:[`editedItem`]="{}">
          <EmailStatementDialoge :baseCrudKey="emailStatementCrudKey" />
        </template>
      </CRUDDialog>
      <CRUDDialog
        :baseCrudKey='comDialogCrudKey'
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Create Comment for Owner Info changes"
        @upsertItem="handleComment"
        dialogDynamicWidth='550'
      ><template v-slot:[`editedItem`]="{}">
         <CommentDialog :baseCrudKey="comDialogCrudKey"/>
        </template>
      </CRUDDialog>
      <CRUDDialog
        :baseCrudKey='comDialogCrudKeyForTax'
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Create Comment for Tax Info changes"
        @upsertItem="handleCommentForTax"
        dialogDynamicWidth='550'
      ><template v-slot:[`editedItem`]="{}">
         <CommentDialog :baseCrudKey="comDialogCrudKeyForTax"/>
        </template>
      </CRUDDialog>
      <CRUDDialog
      v-if="destroyOrReRenderAdjComp"
      :baseCrudKey='adjDialogCrudKey'
      :canSave="true"
      :canCancel="false"
      onlyDialogHeaderName="Creating Adjustment Record for Owner Info changes"
      @upsertItem="handleAdjUpdate"
      dialogDynamicWidth='400'
      ><template v-slot:[`editedItem`]="{}">
        <CreateAdjTaxDialog :baseCrudKey="adjDialogCrudKey"/>
        </template>
      </CRUDDialog>
      <CRUDDialog
        v-if="destroyOrReRenderTaxInfoAdjComp"
        :baseCrudKey='adjDialogForTaxInfoCrudKey'
        :canSave="true"
        :canCancel="false"
        onlyDialogHeaderName="Creating Adjustment Record for Tax Info changes"
        @upsertItem="handleAdjTaxRollUpdate"
        dialogDynamicWidth='400'
        ><template v-slot:[`editedItem`]="{}">
          <CreateAdjTaxDialog :baseCrudKey="adjDialogForTaxInfoCrudKey"/>
        </template>
      </CRUDDialog>
      <!-- for sms -->
      <CRUDDialog
        :baseCrudKey='smsCrudKey'
        :canSave="true"
        :onlyDialogHeaderName="smsDialogtHeader"
        @upsertItem="generateSMS"
        dialogDynamicWidth='550'
        canSaveCustomLabel="Send"
      ><template v-slot:[`editedItem`]="{}">
          <SmsDialog :baseCrudKey="smsCrudKey" />
        </template>
      </CRUDDialog>
      <CRUDDialog
        :baseCrudKey='newCommentsTransCrudKey'
        :canSave="true"
        :canCancel="true"
        onlyDialogHeaderName="Create Comment"
        @upsertItem="handleNewComments"
        dialogDynamicWidth='550'
      ><template v-slot:[`editedItem`]="{}">
         <CommentDialog :baseCrudKey="newCommentsTransCrudKey"
         :isItFromCommentList="true" />
        </template>
      </CRUDDialog>
    <v-dialog v-model="showMailingDialog" max-width="380" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">Statement Mailing</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          Are you mailing this statement?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="confirmStatementMailed(false)">No</v-btn>
          <v-btn text color="primary" @click="confirmStatementMailed(true)">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import router from '@/router';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import '../../../../assets/style.css';
import { clients } from '../../../../util/clients';
import { getRawJwt } from '../../../../util/jwt';
import { printerHandler } from '../../../../util/pdf-to-printer.util';
import { isTulsa } from '../../../../util/shared/county-specific.config';
import { getBusinessDateForPaymentEntry, toIsoDate, toShortDate } from '../../../../util/shared/tmc-global';
import {
  amountFormat,
  amountToNumber,
  defaultGridLoading,
  isAltA,
  isAltB,
  isAltI,
  isAltP,
  isAltS,
  manageGridLoading,
  zipDeFormat,
} from '../../../../util/shared/vue-global';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import AuditDialog from '../../../common/audit/AuditDialog.vue';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { generateQueryString } from '../../../common/base/report/report-util';
import PayrixPaymentDialog from '../../../common/PayrixPaymentDialog.vue';
import Forte2PaymentDialog from '../../../common/Forte2PaymentDialog.vue';
import UploadFile from '../../../common/UploadFile.vue';
import {
  buildPostProcessForDelinquant,
  delQRecords,
  getChangedFields,
  handleColorChange, makeCriteriaStateNullIfEmptyString, postProcessCommentsTrans,
  taxCommonPostProcessTrans,
  taxFeeCheckWitheEfectiveDate,
  taxFeesPostProcessTrans,
  taxPostProcessFeesList,
  taxReasonListDropDownPostProcessTrans,
} from '../../common-utils/CommonTaxFunctionalities';
import {
  buildMailingAddress, commonAdjFuncForTaxrollNOwner, exemptManufacturingStatusCode,
  getHighlightColorForStatusCode, taxCommentTypesObj, toOwnerChangesInput,
  useAbortController,
} from '../../common-utils/tax-common.util';
import { SEARCH_DEBOUNCE_TIMER } from '../../common-utils/constants';
import CommentDialog from '../../TaxCommonComponents/commentDialog.vue';
import CreateAdjTaxDialog from '../../TaxCommonComponents/createAdjTaxDialog.vue';
import CommonActionButtons from '../Common/CommonActionButtons.vue';
import CommonPaymentDialog from '../Common/CommonPaymentDialog.vue';
import EmailStatementDialoge from '../Common/EmailStatementDialoge.vue';
import SmsDialog from '../Common/smsDialog.vue';
import TaxInquiryDialog from '../Common/TaxInquiryDialog.vue';
import { TaxRollHeader } from '../TaxInquiryUtils/TableHeaders.utils';
import { tabs, visibleTabs } from '../TaxInquiryUtils/TaxInquiry.utils';
import { TaxViewOnlyMixin } from '../TaxInquiryUtils/taxViewOnly.mixin';
import TaxrollCriteria from './TaxrollCriteria.vue';
import TaxRollFooter from './TaxRollFooter.vue';
import taxSmsDialogMixin from '../../common-utils/taxSmsDialog.mixin';
import { WIDE_DIALOG_HEIGHT, WIDE_DIALOG_WIDTH } from '../../../../util/shared/dialog-size';

const bc = new BroadcastChannel('tax_inquiry_channel');
bc.onmessage = (event) => {
  if (event.data === 'reload') {
    const currentPath = router.currentRoute.fullPath;
    // check for path also or else it will reload all the pages
    if (currentPath.includes('taxinquiry')) window.location.reload();
    bc.close();
  }
};

const { backendRest } = clients.direct;
export default {
  name: 'TaxrollTransactionList',
  mixins: [taxSmsDialogMixin, TaxViewOnlyMixin],
  components: {
    TaxrollCriteria,
    TaxInquiryDialog,
    CRUDList,
    CRUDDialog,
    TaxRollFooter,
    UploadFile,
    AuditDialog,
    CommonPaymentDialog,
    EmailStatementDialoge,
    CommonActionButtons,
    CommentDialog,
    CreateAdjTaxDialog,
    SmsDialog,
    PayrixPaymentDialog,
    Forte2PaymentDialog,
  },
  data() {
    return {
      tabsList: [...tabs],
      // the tax record dialog's size - shared with the other three hosts of TaxInquiryDialog
      wideDialogWidth: WIDE_DIALOG_WIDTH,
      wideDialogHeight: WIDE_DIALOG_HEIGHT,
      enterSaveInFlight: false,
      baseCrudKey: 'TaxrollTransactionList',
      baseCrudKeyForFeeList: 'TaxrollTransactionFeeList',
      adjBaseCrudKey: 'adjTransactionList',
      headers: TaxRollHeader,
      isItFirstCallOrNot: false,
      showIfTaxAdj: false,
      showMailingDialog: false,
      pendingStatementUrl: null,
      gridLoading: defaultGridLoading(),
      selectedRowData: {},
      userName: '',
      wkstNumber: getWorkstationNumber(),
      paymentCrudKey: 'paymentTransactionList',
      dialogHeaderPayment: 'Payment',
      emailStatementCrudKey: 'emailStatement',
      commentsTransCrudKey: 'commentsTransactionList',
      newCommentsTransCrudKey: 'newCommentsTransactionList',
      emailStatementHeader: 'Email Send',
      comDialogCrudKey: 'comDialog',
      comDialogCrudKeyForTax: 'comDialogForTaxInfo',
      adjDialogCrudKey: 'createAdjTaxDialog',
      adjDialogForTaxInfoCrudKey: 'createAdjTaxInfoDialog',
      smsCrudKey: 'smsTransaction',
      destroyOrReRenderAdjComp: false,
      destroyOrReRenderTaxInfoAdjComp: false,
      smsDialogtHeader: 'SMS Info',
      // upload related
      activeTransItem: undefined,
      formatPidPositions: '',
      attachmentConstants: {
        bucketName: 'taxInquiry',
        program: 'taxInquiry',
        parentObjectType: 'taxInquiryTransaction',
      },
      uploadFileParams: {
        bucketName: 'taxInquiry',
        program: 'taxInquiry',
        parentObjectType: 'taxInquiryTransaction',
      },
      uploadFileClickParams: {
        leftClickFlag: false,
        leftClickDef: undefined,
        rightClickFlag: false,
        rightClickDef: undefined,
      },
      abortController: useAbortController(),
      showTotalDue: [],
      originalItem: null,
      typedTaxIdBuffer: '',
      typedTaxIdDebounceTimer: null,
    };
  },
  created() {
    this.initCriteria();
  },
  mounted() {
    if (this.defaultTaxYearFromTaxSetting) {
      this.isItFirstCallOrNot = true;
      this.handleLoadTIRoll();
    }
    // if (this.latestTaxYear) {
    //   this.isItFirstCallOrNot = true;
    //   this.handleLoadTIRoll();
    // }
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleSelShortCut);
  },
  watch: {
    // latestTaxYear(newVal, oldVal) {
    //   if (newVal && !oldVal) this.criteriaState.taxYear = this.latestTaxYear;
    //   if (newVal !== 0) {
    //     this.isItFirstCallOrNot = true;
    //     this.handleLoadTIRoll();
    //   }
    // },
    defaultTaxYearFromTaxSetting(newVal, oldVal) {
      if (this.isAllYearsDefault) {
        if (!oldVal) {
          this.criteriaState.taxYear = 0;
          this.criteriaState.sortBy = [{ column: 'taxYear', direction: 'desc' }];
        }
      } else if (newVal && !oldVal) {
        this.criteriaState.taxYear = this.defaultTaxYearFromTaxSetting;
      }
      if (newVal !== 0) {
        this.isItFirstCallOrNot = true;
        this.handleLoadTIRoll();
      }
    },
    isVisibleTaxRollList(val) {
      // this is for when the dialog is opened or closed, remove or add the shortcut key listener,
      // payment also has its own listener for the shortcut key
      if (val) {
        window.removeEventListener('keydown', this.handleSelShortCut);
      } else window.addEventListener('keydown', this.handleSelShortCut);
    },
    isVisiblePaymentTransactionList(val) {
      // this is for when the dialog is opened or closed, remove or add the shortcut key listener,
      // payment also has its own listener for the shortcut key
      if (val) {
        window.removeEventListener('keydown', this.handleSelShortCut);
      } else window.addEventListener('keydown', this.handleSelShortCut);
    },
    isVisibleProtestAndPickListTabs(val) {
      // this is for when the dialog is opened or closed, remove or add the shortcut key listener,
      // payment also has its own listener for the shortcut key
      if (val) {
        window.removeEventListener('keydown', this.handleSelShortCut);
      } else window.addEventListener('keydown', this.handleSelShortCut);
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'criteria',
      'selectedTab',
      'index',
      'items',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapGetters('auth/token', ['authUser', 'isTaxAdminAccessible']),
    /**
     * tabsList stays mutable internal state (handleColorChange recolours it as adjustments and
     * mobile records load); this is the filtered view the grid renders. It must stay in step
     * with TaxInquiryDialog's v-tab-items, which filter through the same isTabVisible().
     */
    visibleTabsList() {
      if (!this.isTaxViewOnly) return this.tabsList;
      const keep = visibleTabs(true).map((tab) => tab.id);
      return this.tabsList.filter((tab) => keep.includes(tab.id));
    },
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem,
      mobileLists: (state) => state.tax.taxInquiryTabs.selectedMobile,
      isItOmitOrSa: (state) => state.tax.taxFee.isItOmitOrSa,
      taxRollFeesTable: (state) => state.base.crud.items.taxRollFeesTable,
      isDialogVisible: (state) => state.base.crud.isVisible.TaxrollTransactionList,
      feeListBasedInIds: (state) => state.base.crud.items.TaxrollTransactionFeeList,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      commentsCategory: (state) => state.base.crud.items.sharedTaxComments,
      statementSettingItem: (state) => state.SystemConfig.statementSettingItem || {},
      taxDistrict: (state) => state.base.crud.items.sharedTaxDistrict,
      isVisibleTaxRollList: (state) => state.base.crud.isVisible.TaxrollTransactionList,
      isVisiblePaymentTransactionList: (state) => state.base.crud.isVisible.paymentTransactionList,
      isVisibleProtestAndPickListTabs: (state) => state.base.crud.isVisible.ProtestAndPickListTabs,
      isVisibleAdjTaxInfoDialog: (state) => state.base.crud.isVisible.createAdjTaxInfoDialog,
      isVisibleSmsDialog: (state) => state.base.crud.isVisible.smsTransaction,
      isVisibleCommentsDialog: (state) => state.base.crud.isVisible.newCommentsTransactionList,
      reasonListDropDown: (state) => state.base.crud.items.reasonListDropDown,
      isPayrixDialogOpen: (state) => state.common.payrixPayment.isDialogOpen,
      isForte2DialogOpen: (state) => state.common.forte2Payment.isDialogOpen,
      payrixPaymentType: (state) => state.common.payrixPayment.payrixPaymentType,
      forte2PaymentType: (state) => state.common.forte2Payment.forte2PaymentType,
      taxStatusCodesSharedHighlight: (state) => state.base.crud.items.taxStatusCodesSharedHighlight,
    }),
    fieldNameListsForForte2Dialog() {
      if (this.forte2PaymentType === 'CREDIT') {
        return [
          'Total Due',
          'Convenience fee (credit)',
          'Convenience fee (debit)',
        ];
      } if (this.forte2PaymentType === 'ECHECK') {
        // The flat eCheck fee is itemized inside the dialog's own breakdown block, not
        // this top checkout list — so a single Amount Due label pairs 1:1 with its amount.
        return [
          'Amount Due',
        ];
      }
      return [];
    },
    fieldNameListsForPayrixDialog() {
      if (this.payrixPaymentType === 'CREDIT') {
        return [
          'Amount Due',
          'Convenience fee (credit)',
          'Convenience fee (debit)',
        ];
      } if (this.payrixPaymentType === 'ECHECK') {
        return [
          'Amount Due',
          'eCheck Fee',
        ];
      }
      return [];
    },
    getTaxStatusCodesSharedHighlight() {
      // get the highlight color for the status codes
      if (this.taxStatusCodesSharedHighlight.length) {
        return this.taxStatusCodesSharedHighlight.reduce((acc, item) => {
          acc[item.statusCode] = item.highlightColor;
          return acc;
        }, {});
      }
      return {};
    },
    getTaxRecordHighlightColors() {
      const colors = [{ varName: 'totalDueIsNegative', varCol: '#ffcdd2' }];
      const otherColors = [];
      getHighlightColorForStatusCode.forEach((item) => {
        otherColors.push({ varName: item.value, varCol: item.value });
      });
      return [...otherColors, ...colors];
    },
    defaultTaxYearFromTaxSetting() {
      return Number((this.taxSettingItem || {}).taxYear) || 0;
    },
    isAllYearsDefault() {
      return ((this.taxSettingItem || {}).taxInquiryDefaultYearScope) === 'allYears';
    },
    getUpdatedTabVal: {
      get() {
        return this.selectedTab(this.baseCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKey, value]);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    editSMSItem: {
      get() {
        return this.item(this.smsCrudKey);
      },
      set(value) {
        this.setItem([this.smsCrudKey, value]);
      },
    },
    editEmailItem: {
      get() {
        return this.item(this.emailStatementCrudKey);
      },
      set(value) {
        this.setItem([this.emailStatementCrudKey, value]);
      },
    },
    getActiveTransID() {
      return this.activeTransItem && this.activeTransItem._id;
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    defaultSortBy() {
      return [
        {
          column: 'taxId',
          direction: 'asc',
        },
      ];
    },
    dynamicHeaders() {
      const headerItems = [...this.headers];
      const countyName = (this.globalSettingItem || {}).countyName || '';

      // this is only for tulsa county
      if (isTulsa(countyName)) {
        headerItems.push({ text: 'Cert#', value: 'certificate' });
      }
      if (this.criteriaState.situsStreetName && !headerItems.some((el) => el.text === 'Street Name')) {
        headerItems.push({ text: 'Street Name', value: 'situsStreetName' });
      }
      if (this.criteriaState.addition && !headerItems.some((el) => el.text === 'Addition')) {
        headerItems.push({ text: 'Addition', value: 'addition' });
      }

      if (this.criteriaState.addition && this.criteriaState.situsStreetName) {
        const streetIndex = headerItems.findIndex((el) => el.text === 'Street Name');
        if (streetIndex !== -1) headerItems.splice(streetIndex, 1);
      }
      if (this.criteriaState.addition === null && this.criteriaState.situsStreetName === null) {
        return headerItems.filter((el) => el.text !== 'Street Name' && el.text !== 'Addition');
      }

      return headerItems;
    },
    checkTheUserIsTaxAdmin() {
      const userRole = this.isTaxAdminAccessible;
      return userRole;
    },
  },
  methods: {
    ...mapMutations('tax/taxFee', ['setIsItOmitOrSa']),
    ...mapActions('tax/taxFee', [
      'loadTaxRollFeesTable',
      'multipleUpsertTaxFees',
      'taxFeesBasedOnIds',
    ]),
    ...mapActions('shared/taxStatusCodesShared', [
      'loadTaxStatusCodesSharedRecords',
    ]),
    ...mapMutations('base/crud', ['setIsVisible', 'setCriteria', 'setItem', 'setItems', 'setHighlightedId', 'setIndex', 'setSelectedTab']),
    ...mapActions('shared/TaxStreets', ['loadTaxStreetsRecords']),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
      'upsertTaxInquiryTransaction',
      'patchTaxInquiryTransaction',
      'callMakeGLobalTaxIdUndefined',
    ]),
    ...mapMutations('tax/taxInquires', [
      'setTaxRateTaxInquiry',
    ]),
    ...mapActions('tax/taxInquires', [
      'sendMail',
    ]),
    ...mapActions('tax/taxComments', ['loadTaxComments', 'upsertTaxCommentTrans']),
    ...mapMutations('tax/taxInquiryTabs', ['setComments']),
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapActions('tax/taxPayment', [
      'upsertTaxPayment',
      'loadTaxPayments',
    ]),
    ...mapActions('tax/taxInquiryTabs', [
      'UpsertPickListSingleNMultiplipleHybrid',
      'loadTabsAdjustments',
    ]),
    ...mapActions('tax/taxRollAdjustments', ['upsertTaxRollAdjustments']),
    ...mapActions(['reAuth']),
    ...mapActions(['custumColrFlashMsg']),
    ...mapActions('shared/taxLevy', [
      'loadTaxLevy',
    ]),
    ...mapActions('shared/taxReasonCode', [
      'loadReasonCode',
    ]),
    ...mapActions('common/payrixPayment', [
      'setPaymentSuccessFlag',
      'setLastSavedPaymentItem',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setPaymentDialogBusinessDate',
      'setUpsertItem',
    ]),
    async initCriteria() {
      const initialCriteria = this.criteriaState;
      if (!initialCriteria.fromOwnerSearch) { // when using browseBid from owner search
        this.criteriaState = {};
        if (this.isAllYearsDefault) {
          this.criteriaState.taxYear = initialCriteria.taxYear || 0;
          this.criteriaState.sortBy = [{ column: 'taxYear', direction: 'desc' }];
        } else {
          this.criteriaState.taxYear = initialCriteria.taxYear || this.defaultTaxYearFromTaxSetting
          || this.latestTaxYear;
        }
      }
      this.criteriaState.penaltyDateValue = initialCriteria.penaltyDateValue || toShortDate();
      this.loadConfig({ requiredScope: 'taxConfig' });
      this.loadConfig({ requiredScope: 'statementConfig' });
      this.loadConfig({ requiredScope: 'global' });

      // const todaysDate = localStorage.getItem('tax_payment_filter_date') || this.todaysDate;
      const todaysDate = toShortDate();
      this.loadConfig({ requiredScope: 'paymentConfig' }).then(() => {
        const bussDateChangeIndividually = this.paymentSettingItem.changeBussDateIndividually;
        if (!bussDateChangeIndividually) {
          const bussDate = this.globalSettingItem.businessDate
            ? toShortDate(this.globalSettingItem.businessDate) : todaysDate;
          this.setPaymentDialogBusinessDate(bussDate);
        } else {
          const localBussDate = getBusinessDateForPaymentEntry();
          const bussDate = localBussDate ? toShortDate(localBussDate) : todaysDate;
          this.setPaymentDialogBusinessDate(bussDate);
        }
      }).catch((err) => console.error(err));
      const criteriaList = {
        limit: 100,
        skip: 0,
        sortBy: [{
          column: 'streetName',
          direction: 'asc',
        }],
      };
      this.loadTaxStreetsRecords({
        criteria: criteriaList,
        baseCrudKey: 'taxStreetsTable',
      });
      this.loadReasonCode({
        criteria: { sortBy: [{ column: 'reasonCode', direction: 'asc' }] },
        postProcessTrans: taxReasonListDropDownPostProcessTrans,
        baseCrudKey: 'reasonListDropDown',
      });
      this.userName = this.authUser;
      this.wkstNumber = getWorkstationNumber();
      window.addEventListener('keydown', this.handleSelShortCut);
    },
    upsertFuncCall() {
      this.handleSingleOrArrowClick(this.selectedRowData);
    },
    async handleLoadTIRoll(combinedCriteria, fromWhere) {
      if (this.isItFirstCallOrNot) {
        this.abortController.abort(); // abort previous fetch here
        this.abortController = useAbortController(); // reinitializing the abourtcontroller
        const { signal } = this.abortController;
        this.selectedRowData = {};
        this.formatPidPositions = this.taxSettingItem.pidValue || '';
        if (this.criteriaState.fromOwnerSearch) {
          this.criteriaState.taxYear = 0;
          this.criteriaState.sortBy = [{ column: 'taxYear', direction: 'desc' }];
        }
        manageGridLoading(this, true, 'Searching...');
        const { baseCrudKey } = this;
        let criteria = {
          ...this.criteriaState,
        };
        if (fromWhere === 'fromBrowseBidClick') {
          criteria = { ...combinedCriteria };
        }
        delete criteria.fromOwnerSearch;
        delete criteria.penaltyDateValue;
        this.criteriaState.fromOwnerSearch = false;
        // Atlas Search intent from SystemConfig global (configuration.useAtlasSearch).
        // Backend still guards on index presence and falls back to regex, so safe to always send.
        criteria.useAtlasSearch = !!(this.globalSettingItem || {}).useAtlasSearch;
        await this.loadTaxInquires({
          criteria,
          baseCrudKey,
          postProcessTrans: this.taxPostProcessTransWithFees,
          signal,
        }).then((val) => {
          if (val.length && val.length === 1) {
            // when there is a single record is present select that record
            const singleItem = val[0];
            this.setHighlightedId([this.baseCrudKey, singleItem._id]);
            this.selectedRowData = singleItem;
            this.setItem([baseCrudKey, singleItem]);
            this.handleSingleOrArrowClick(singleItem, false);
          } else if (fromWhere !== 'fromTaxInquiryDialog') {
            this.setDefaultSelectedItems();
            this.selectedRowData = {};
            this.setItem([baseCrudKey, {}]);
          }
          this.onPenaltyDateChange();
        }).finally(() => {
          manageGridLoading(this, false);
        });
        this.resetStoreItems();
      }
    },
    onPenaltyDateChange() {
      const itemsList = this.items(this.baseCrudKey);
      if (this.criteriaState.taxYear === 0
          && (this.criteriaState.baseId || this.criteriaState.propertyOrParcelId)) {
        const feesAndPenTotal = itemsList
          .reduce((acc, item) => acc + amountToNumber(item.feesAndPen || 0), 0);
        this.showTotalDue = [null, null, null, null, null, null, null, null,
          amountFormat(feesAndPenTotal)];
      } else this.showTotalDue = [];
    },
    // Enter in the record dialog does what the visible Save button does. It used to fall
    // through to CRUDDialog.close(true), which reset the record and threw away every
    // unsaved edit on every tab without a confirm.
    saveOnEnter() {
      // the adjustment/comment tabs show no Save button - Enter has nothing to do there
      if (this.areTheyAreForms()) return;
      if (this.enterSaveInFlight) return;
      this.enterSaveInFlight = true;
      Promise.resolve(this.upsertRecords(false))
        .finally(() => { this.enterSaveInFlight = false; });
    },
    closeDialog() {
      this.getUpdatedTabVal = 0;
      this.setIsVisible([this.baseCrudKey, false]);
      this.originalItem = null;
    },
    crudDialogClose() {
      this.selectedRowData = {};
      this.setIsVisible(['createOmit', false]); // to close omit dialog
      this.resetStoreItems();
    },
    resetStoreItems() {
      // to reset when criteria changes
      this.setItems(['TaxRollDelq', []]);
      this.setItems(['TaxRollStatusCodes', []]);
      this.setItems(['paymentsRecords', []]);
      this.setItems(['GeneralDetailsPayments', []]); // for taxinfo-payment
      this.setItems(['taxRollComments', []]);
      this.setItems(['historyTransactionListBaseCrudKey', []]);
    },
    loadTaxCommentsForFooter(criteria) {
      this.loadTaxComments({
        criteria: {
          ...criteria,
          sortBy: [{ column: 'createdAt', direction: 'desc' }],
        },
        baseCrudKey: 'taxRollComments',
        postProcessTrans: this.postProcessTrans,
      });
    },
    refreshDelinquentRecords() {
      const { baseId, taxId } = this.selectedRowData;
      if (baseId) {
        this.loadTaxInquires({
          criteria: { delq: true, baseId, taxId },
          baseCrudKey: 'TaxRollDelq',
          fields: delQRecords,
          postProcessTrans: this.preBuildPostProcessForDelinquant,
        });
      }
    },
    handleSingleOrArrowClick(fromCrud, updateTaxIdInCriteria = false) {
      if (this.isItOmitOrSa) this.setIsItOmitOrSa(false);
      this.selectedRowData = { ...fromCrud };
      if (fromCrud.taxId && updateTaxIdInCriteria) {
        this.setCriteria([this.baseCrudKey, { ...this.criteriaState, taxId: fromCrud.taxId }]);
      }
      if (fromCrud.taxYear && fromCrud.taxId) {
        const criteria = { taxYear: fromCrud.taxYear, taxId: fromCrud.taxId };
        this.loadTaxPayments({ criteria, baseCrudKey: 'paymentsRecords' });
        // taxComments is TaxAuth-only on the backend and the footer grid is hidden anyway, so
        // the view-only persona must not fire the query at all - otherwise selecting any row
        // raises a 403 toast.
        if (this.canActOnTaxRecord) this.loadTaxCommentsForFooter(criteria);
        // status codes will be in array. If its empty no need to call the api
        if ((fromCrud.statusCode || []).length) {
          this.loadTaxStatusCodesSharedRecords({
            criteria: { statusCodeList: fromCrud.statusCode },
            baseCrudKey: 'TaxRollStatusCodes',
          });
        } else this.setItems(['TaxRollStatusCodes', []]);

        if (fromCrud.baseId) {
          this.loadTaxInquires({
            criteria: {
              delq: true,
              baseId: fromCrud.baseId,
              taxId: fromCrud.taxId,
            },
            baseCrudKey: 'TaxRollDelq',
            fields: delQRecords,
            postProcessTrans: this.preBuildPostProcessForDelinquant,
          });
        } else this.setItems(['TaxRollDelq', []]);
      }
    },
    postProcessTrans(items) {
      const updatedItems = postProcessCommentsTrans(items, this.commentsCategory);
      return updatedItems;
    },
    async handleDoubleClick(fromCrud, baseCrudkey, doesItRequireRePopulate) {
      this.resetTabsList();
      if (this.isItOmitOrSa) this.setIsItOmitOrSa(false);
      this.selectedRowData = { ...fromCrud };
      this.originalItem = JSON.parse(JSON.stringify(fromCrud));
      if ((!!fromCrud.taxYear && !!fromCrud.taxId) || doesItRequireRePopulate) {
        if (doesItRequireRePopulate) this.setItem([this.baseCrudKey, { ...fromCrud }]);
        const criteria = { taxYear: fromCrud.taxYear, taxId: fromCrud.taxId };
        const doesItHasMobileListOrNot = [];
        if (Number(fromCrud.mobileHome || 0) > 0) {
          doesItHasMobileListOrNot.push(doesItHasMobileListOrNot);
        }
        const returnedList = handleColorChange(
          'Mobile',
          doesItHasMobileListOrNot,
          tabs,
        );
        this.tabsList = [...returnedList];
        this.loadTaxPayments({ criteria, baseCrudKey: 'GeneralDetailsPayments' }); // for taxinfo-payment
        this.loadTaxRollFeesTable({
          criteria,
          baseCrudKey: 'taxRollFeesTable',
          postProcessTrans: this.taxFeesPreProcessTrans,
        });
        if (this.canActOnTaxRecord) {
          this.loadTaxComments({
            criteria,
            baseCrudKey: this.commentsTransCrudKey,
            postProcessTrans: this.postProcessTrans,
          }).then(() => {
            this.setDefaultComments();
          });
          this.setItems(['historyTransactionListBaseCrudKey', []]); // to reset the items
          if (fromCrud.propertyOrParcelId) {
            this.loadTaxInquires({
              criteria: { propertyOrParcelId: fromCrud.propertyOrParcelId },
              baseCrudKey: 'historyTransactionListBaseCrudKey',
              postProcessTrans: this.taxPostProcessTrans,
            });
          }
        }
        const returnedAdjArr = await this.loadTabsAdjustments({
          criteria,
          baseCrudKey: 'TaxRollAdjustments',
        });
        const returnedAdjList = handleColorChange(
          'Adjustments',
          returnedAdjArr,
          tabs,
        );
        this.tabsList = [...returnedAdjList];
        let taxLevyTotal = null;
        if (fromCrud.schoolDistrict && this.taxDistrict) {
          const filDist = this.taxDistrict.filter((ft) => ft.districtCode
          === fromCrud.schoolDistrict);
          if (filDist.length) {
            const critLevy = {
              taxDistrict: filDist[0]._id,
              taxYear: fromCrud.taxYear,
            };
            const taxLevyData = await this.loadTaxLevy({
              criteria: critLevy,
            });
            if (taxLevyData.length) {
              taxLevyTotal = taxLevyData
                .reduce((acc, item) => acc + amountToNumber(item.mills || 0), 0);
            }
          }
        }
        this.setTaxRateTaxInquiry(taxLevyTotal);
      }
    },
    setDefaultComments() {
      this.$nextTick(() => {
        this.setComments([]);
      });
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.setHighlightedId([this.baseCrudKey, '']);
      });
    },
    resetTabsList() {
      const mappedArr = (tabs || []).map((ft) => {
        const item = ft;
        item.color = '';
        return item;
      });
      this.tabsList = mappedArr; // reseting tabs
    },
    checkFormValidOrNot(whatColor = '') {
      const mappedArr = (tabs || []).map((ft) => {
        const item = ft;
        if (item.id === 0) item.color = whatColor;
        if (item.id === 1) item.color = whatColor;
        return item;
      });
      this.tabsList = mappedArr;
    },
    async upsertRecords(isFromTaxInquiryDialog = false, overrideValidate = false) {
      // One guard covers the lot for the view-only persona: the Save button, Enter-to-save, and
      // the two follow-up dialogs this method opens (Create Comment / Create Adjustment for
      // Owner-Info and Tax-Info changes) all funnel through here.
      if (this.isTaxViewOnly) return;
      const validate = this.$refs.crudList.$refs.crudDialog.validateForm();
      this.checkFormValidOrNot('red');
      // if the validate is false and the overrideValidate is false, then return
      if (!overrideValidate) {
        if (!validate) return;
      }
      const item = this.item(this.baseCrudKey);
      const updatedItem = { ...this.item(this.baseCrudKey) };
      const { baseCrudKey } = this;
      const getAllFeeTotal = taxFeeCheckWitheEfectiveDate(this.taxRollFeesTable, this.todaysDate);
      updatedItem.userName = this.userName;
      updatedItem.wkstNumber = this.wkstNumber;
      updatedItem.schoolDistrict = updatedItem.taxDistrict;
      updatedItem.zip = zipDeFormat(updatedItem.zip);
      updatedItem.propertyOrParcelId = (updatedItem.propertyOrParcelId || '').replace(/-/g, '');
      updatedItem.mhPropertyOrParcelId = (updatedItem.mhPropertyOrParcelId || '').replace(/-/g, '');
      updatedItem.pIdOfRealEstate = (updatedItem.pIdOfRealEstate || '').replace(/-/g, '');
      updatedItem.penaltyStartDate = updatedItem.penaltyStartDate
        ? toIsoDate(updatedItem.penaltyStartDate) : updatedItem.penaltyStartDate;
      updatedItem.mhDecalDate = updatedItem.mhDecalDate
        ? toIsoDate(updatedItem.mhDecalDate) : updatedItem.mhDecalDate;
      const isExemptManufacturing = (updatedItem.statusCode || [])
        .includes(exemptManufacturingStatusCode);
      updatedItem.totalFee = isExemptManufacturing ? 0 : getAllFeeTotal;
      delete updatedItem.taxDistrict;
      delete updatedItem.hasFiles;
      delete updatedItem.getPenRateWithMonths;
      delete updatedItem.penaltyAmount;
      delete updatedItem.penaltyDateValue;
      delete updatedItem.feesAndPen;
      delete updatedItem.totalDueIsNegative;
      Object.keys(updatedItem).forEach((key) => {
        if (key.startsWith('#')) delete updatedItem[key];
      });
      // Compute only the changed fields for patch
      const changedKeys = this.originalItem
        ? new Set(Object.keys(getChangedFields(this.originalItem, item)))
        : null;
      let patchPayload;
      if (changedKeys) {
        patchPayload = { _id: updatedItem._id };
        patchPayload.userName = updatedItem.userName;
        patchPayload.wkstNumber = updatedItem.wkstNumber;
        Object.keys(updatedItem).forEach((key) => {
          if (changedKeys.has(key)) {
            patchPayload[key] = updatedItem[key];
          }
        });
        // taxDistrict is renamed to schoolDistrict in the transformation
        if (changedKeys.has('taxDistrict')) {
          patchPayload.schoolDistrict = updatedItem.schoolDistrict;
        }
      } else {
        patchPayload = updatedItem;
      }
      const returnRes = makeCriteriaStateNullIfEmptyString(patchPayload);
      const returnedVal = await this.patchTaxInquiryTransaction({
        item: returnRes,
        baseCrudKey,
        postProcessTrans: this.taxPostProcessTrans,
      });
      // this is used to create adjustment and comment
      if ((returnedVal || {}).commentForTaxInfoChanges || (returnedVal || {}).commentOnlyForOwner) {
        if ((returnedVal || {}).commentForTaxInfoChanges) { // tax-info changes
          const commentItem = {
            taxYear: returnedVal.taxYear,
            taxId: returnedVal.taxId,
            beforeChange: returnedVal.beforeChangeForTax,
            afterChange: returnedVal.afterChangeForTax,
            category: taxCommentTypesObj.taxRecordCode,
            taxInquiryTransaction: returnedVal._id,
          };
          commentItem.fixedComment = returnedVal.commentForTaxInfoChanges;
          commentItem.comment = '';
          commentItem.createdAt = returnedVal.commentCreatedDate || toIsoDate();

          if (this.checkTheUserIsTaxAdmin) {
            // for tax-admin we can automatically create comment
            this.handleCommentForTax(commentItem);
          } else {
            this.setItem([this.comDialogCrudKeyForTax, commentItem]);
            this.setIsVisible([this.comDialogCrudKeyForTax, true]);
          }
          if (this.taxSettingItem.updateTaxrollChangesAdjFlag) {
            const adjItem = commonAdjFuncForTaxrollNOwner(returnedVal,
              this.taxSettingItem.updateTaxrollChangesAdjType);
            this.setItem([this.adjDialogForTaxInfoCrudKey, adjItem]);
            this.destroyOrReRenderTaxInfoAdjComp = true;
            this.setIsVisible([this.adjDialogForTaxInfoCrudKey, true]);
          }
        }
        if ((returnedVal || {}).commentOnlyForOwner) { // owner info changes
          const commentItem = {
            taxYear: returnedVal.taxYear,
            taxId: returnedVal.taxId,
            beforeChange: buildMailingAddress(this.originalItem),
            afterChange: buildMailingAddress(returnedVal),
            ownerChanges: toOwnerChangesInput(returnedVal.ownerChanges),
            category: taxCommentTypesObj.ownerInfoCode,
            taxInquiryTransaction: returnedVal._id,
          };
          commentItem.fixedComment = returnedVal.commentOnlyForOwner;
          commentItem.comment = '';
          commentItem.createdAt = returnedVal.commentCreatedDate || toIsoDate();
          this.setItem([this.comDialogCrudKey, commentItem]);
          this.setIsVisible([this.comDialogCrudKey, true]);
          if (this.taxSettingItem.updateOwnerChangesAdjFlag) {
            const adjItem = commonAdjFuncForTaxrollNOwner(returnedVal,
              this.taxSettingItem.updateOwnerChangesAdjType);
            this.setItem([this.adjDialogCrudKey, adjItem]);
            this.destroyOrReRenderAdjComp = true;
            this.setIsVisible([this.adjDialogCrudKey, true]);
          }
        }
        if (!isFromTaxInquiryDialog) await this.handleLoadTIRoll();
      }
      if (isFromTaxInquiryDialog) {
        const criteria = { taxYear: item.taxYear, taxId: item.taxId };
        this.loadTaxComments({
          criteria,
          baseCrudKey: this.commentsTransCrudKey,
          postProcessTrans: this.postProcessTrans,
        }).then(() => {
          this.setDefaultComments();
        });
      }
      if (isExemptManufacturing) {
        this.editedItem.feesAndPen = 0;
        this.editedItem.getPenRateWithMonths = 0;
        this.editedItem.penaltyAmount = 0;
        this.editedItem.totalFee = 0;
      }
      this.selectedUpsertData = returnedVal;
      this.setIsVisible(['createOmit', false]); // to close omit dialog
      if (!isFromTaxInquiryDialog) this.closeDialog();
      this.checkFormValidOrNot('');
      await this.callMakeGLobalTaxIdUndefined({ type: 'omittedProperties' });
    },
    async handleComment(updatedItem) {
      const item = updatedItem;
      item.comment = `${item.fixedComment} ${(updatedItem.comment || '').replace(/\n/g, '')}`;
      item.userName = this.userName;
      item.wkstNumber = this.wkstNumber;

      if (item.reasonCode) { // to add reason-desc to the comment
        const reasonCodeWithDesc = (this.reasonListDropDown || [])
          .filter((ft) => ft.value === item.reasonCode);
        if (reasonCodeWithDesc.length) {
          item.comment = `${item.comment} Per ${reasonCodeWithDesc[0].name}`;
        }
      }
      delete item.fixedComment;
      await this.upsertTaxCommentTrans({
        item,
        baseCrudKey: this.comDialogCrudKey,
      }).then(() => {
        this.setItem([this.comDialogCrudKey, {}]);
      });
    },
    async handleCommentForTax(updatedItem) {
      const item = updatedItem;
      item.comment = `${item.fixedComment} ${(updatedItem.comment || '').replace(/\n/g, '')}`;
      item.userName = this.userName;
      item.wkstNumber = this.wkstNumber;

      if (item.reasonCode) { // to add reason-desc to the comment
        const reasonCodeWithDesc = (this.reasonListDropDown || [])
          .filter((ft) => ft.value === item.reasonCode);
        if (reasonCodeWithDesc.length) {
          item.comment = `${item.comment} Per ${reasonCodeWithDesc[0].name}`;
        }
      }
      delete item.fixedComment;
      await this.upsertTaxCommentTrans({
        item,
        baseCrudKey: this.comDialogCrudKeyForTax,
      }).then(() => {
        this.setItem([this.comDialogCrudKeyForTax, {}]);
      });
    },
    addNewComments() {
      const doesItHaveData = Object.keys(this.selectedRowData).length || 0;
      if (!doesItHaveData) {
        this.custumColrFlashMsg({ msg: 'Please select a record' });
        return;
      }
      const item = {
        taxYear: this.selectedRowData.taxYear,
        taxId: this.selectedRowData.taxId,
        category: taxCommentTypesObj.userCommentCode,
      };
      this.setItem([this.newCommentsTransCrudKey, item]);
      this.setIsVisible([this.newCommentsTransCrudKey, true]);
    },
    async handleNewComments(item) {
      const wkst = getWorkstationNumber();

      const updatedItem = { ...item };
      updatedItem.taxYear = this.selectedRowData.taxYear;
      updatedItem.taxId = this.selectedRowData.taxId;
      updatedItem.taxInquiryTransaction = this.selectedRowData._id;
      updatedItem.category = item.category ? item.category : 9; // set default category as 9
      if (updatedItem.category === 9) {
        const userName = this.authUser;
        updatedItem.comment = `${item.comment} by user ${userName}, Wkst-${wkst}`;
      }
      delete updatedItem.categoryName;
      delete updatedItem.isItCategorySeven;
      await this.upsertTaxCommentTrans({
        item: updatedItem,
      }).then(() => {
        const criteria = { taxYear: item.taxYear, taxId: item.taxId };
        this.loadTaxCommentsForFooter(criteria);
      });
    },
    handleAdjUpdate(updatedItem) {
      const adjItem = updatedItem;
      adjItem.certDate = updatedItem.certDate ? toIsoDate(updatedItem.certDate) : toIsoDate();
      adjItem.adjDate = toIsoDate();
      adjItem.adjOrUpd = 'UPDATE';
      this.upsertTaxRollAdjustments({
        item: adjItem,
      }).then(() => {
        this.setItem([this.adjDialogCrudKey, {}]);
        this.destroyOrReRenderAdjComp = false;
      }).catch((err) => console.error(err));
    },
    handleAdjTaxRollUpdate(updatedItem) {
      const adjItem = updatedItem;
      adjItem.certDate = updatedItem.certDate ? toIsoDate(updatedItem.certDate) : toIsoDate();
      adjItem.adjDate = toIsoDate();
      adjItem.adjOrUpd = 'UPDATE';
      this.upsertTaxRollAdjustments({
        item: adjItem,
      }).then(() => {
        this.setItem([this.adjDialogForTaxInfoCrudKey, {}]);
        this.destroyOrReRenderTaxInfoAdjComp = false;
      }).catch((err) => console.error(err));
    },
    activateTransaction(val) {
      this.activeTransItem = val;
    },
    async addToList() {
      const itemData = { ...this.selectedRowData };
      if (Object.keys(itemData).length > 0) {
        const pickListProfileName = localStorage.getItem('pick-list-profile-name');
        const item = {
          mutipleIds: [itemData._id],
          // workstation: Number(this.wkstNumber),
          addUnpaids: this.paymentSettingItem.addAllUnpaidsToPickList || false,
        };
        // if profile name is present then use it otherwise use workstation
        if (pickListProfileName) item.profileName = pickListProfileName;
        else item.workstation = Number(this.wkstNumber);
        await this.UpsertPickListSingleNMultiplipleHybrid({
          item,
          baseCrudKey: 'pickListTable',
        });
      }
    },
    preBuildPostProcessForDelinquant(items) {
      const retData = buildPostProcessForDelinquant(items, this.taxSettingItem || {});
      return retData;
    },
    handlePaymentDialogClick() {
      this.setIndex(['paymentTransactionList', -1]);
      this.$refs.commonPayment.handlePaymentDialog();
    },
    handleEmailStatement() {
      const itemData = this.item(this.baseCrudKey);
      this.editEmailItem.taxYear = itemData.taxYear;
      this.editEmailItem.taxId = itemData.taxId;
      this.editEmailItem.emailAdd = itemData.emailAddess;
      // Default ON when the record has no address on file yet, OFF when the field is
      // pre-filled with what's already stored - the user can always override before sending.
      this.editEmailItem.saveEmailToRecord = !itemData.emailAddess;
      this.editEmailItem.bccEmailAddress = this.statementSettingItem.bccEmailAddress;
      this.editEmailItem.subjectLine = this.statementSettingItem.subjectLine;
      this.editEmailItem.subjectBody = this.statementSettingItem.subjectBody;
      const penaltyDate = this.editedItem.penaltyDateValue || this.criteriaState.penaltyDateValue;
      this.editEmailItem.wkstID = Number(this.wkstNumber);
      this.editEmailItem.penaltyDate = penaltyDate;
      this.setIsVisible([this.emailStatementCrudKey, true]);
    },
    taxFeesPreProcessTrans(items) {
      const updatedItems = taxFeesPostProcessTrans(items);
      return updatedItems;
    },
    taxPostProcessTrans(items) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const updatedItems = taxCommonPostProcessTrans(items,
        this.todaysDate, this.taxSettingItem, this.criteriaState.penaltyDateValue,
        formatPidPositions, this.getTaxStatusCodesSharedHighlight);
      return updatedItems;
    },
    async taxPostProcessTransWithFees(items) {
      // to filter only the still due tax records
      const filterUnPaidTaxes = (items || []).filter((ft) => amountToNumber(ft.totalDue) > 0);
      let feesData = [];
      if (filterUnPaidTaxes.length) {
        const ids = filterUnPaidTaxes.map((ft) => ft._id);
        feesData = await this.taxFeesBasedOnIds(
          {
            criteria: { ids },
            baseCrudKey: this.baseCrudKeyForFeeList,
            postProcessTrans: taxPostProcessFeesList,
            // signal,
          },
        );
      }
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const updatedItems = taxCommonPostProcessTrans(items,
        this.todaysDate, this.taxSettingItem, this.criteriaState.penaltyDateValue,
        formatPidPositions, this.getTaxStatusCodesSharedHighlight, feesData);
      return updatedItems;
    },
    areTheyAreForms() {
      // to chheck if the form is in adjustment or comment
      if (this.getUpdatedTabVal === 2 || this.getUpdatedTabVal === 3
      || this.getUpdatedTabVal === 5 || this.getUpdatedTabVal === 6) return true;
      return false;
    },
    callTheArrowDownShortCut() {
      const keyDownForRowSel = { key: 'ArrowDown' };
      this.$refs.crudList.keyboardShortCutFunc(keyDownForRowSel);
    },
    handleSelShortCut(e) {
      const activeTag = document.activeElement && document.activeElement.tagName;
      const isInputFocused = activeTag === 'INPUT' || activeTag === 'TEXTAREA' || activeTag === 'SELECT';
      if (e.key === 'Escape') {
        this.typedTaxIdBuffer = '';
        if (this.typedTaxIdDebounceTimer) clearTimeout(this.typedTaxIdDebounceTimer);
        const isAnyDialogOpen = this.isVisibleTaxRollList
          || this.isVisiblePaymentTransactionList
          || this.isVisibleProtestAndPickListTabs
          || this.isVisibleAdjTaxInfoDialog
          || this.isVisibleSmsDialog
          || this.isVisibleCommentsDialog;
        if (!isInputFocused && !isAnyDialogOpen) {
          this.setCriteria([this.baseCrudKey, { ...this.criteriaState, taxId: null }]);
          this.isItFirstCallOrNot = true;
          this.handleLoadTIRoll();
        }
        return;
      }
      if (isInputFocused) return;
      if (e.key >= '0' && e.key <= '9' && !e.altKey && !e.ctrlKey && !e.metaKey) {
        e.preventDefault();
        this.typedTaxIdBuffer += e.key;
        this.setCriteria([this.baseCrudKey, { ...this.criteriaState, taxId: Number(this.typedTaxIdBuffer) }]);
        if (this.typedTaxIdDebounceTimer) clearTimeout(this.typedTaxIdDebounceTimer);
        this.typedTaxIdDebounceTimer = setTimeout(() => {
          this.typedTaxIdBuffer = '';
          this.isItFirstCallOrNot = true;
          this.handleLoadTIRoll();
        }, SEARCH_DEBOUNCE_TIMER);
        return;
      }
      if (e.key === 'Backspace' && this.typedTaxIdBuffer.length) {
        e.preventDefault();
        this.typedTaxIdBuffer = this.typedTaxIdBuffer.slice(0, -1);
        const newTaxId = this.typedTaxIdBuffer.length ? Number(this.typedTaxIdBuffer) : null;
        this.setCriteria([this.baseCrudKey, { ...this.criteriaState, taxId: newTaxId }]);
        if (this.typedTaxIdDebounceTimer) clearTimeout(this.typedTaxIdDebounceTimer);
        if (this.typedTaxIdBuffer.length) {
          this.typedTaxIdDebounceTimer = setTimeout(() => {
            this.typedTaxIdBuffer = '';
            this.isItFirstCallOrNot = true;
            this.handleLoadTIRoll();
          }, SEARCH_DEBOUNCE_TIMER);
        }
        return;
      }
      // Alt+A/P/S/B/I are shortcuts for Add to List / Pay Now / Print Statement / Browse BID /
      // Info Sheet - all removed for the view-only persona, so the keys are inert too. The
      // number-key search, Esc and F9/F10 copy above are read-only and stay.
      if (this.isTaxViewOnly) return;
      const isAltAres = isAltA(e);
      const isAltPres = isAltP(e);
      const isAltSres = isAltS(e);
      const isAltIres = isAltI(e);
      const isAltBres = isAltB(e);
      const doesItHaveData = Object.keys(this.selectedRowData).length || 0;
      if (isAltAres && doesItHaveData) {
        this.addToList();
        this.callTheArrowDownShortCut();
      } else if (isAltPres && doesItHaveData) this.handlePaymentDialogClick();
      else if (isAltSres && doesItHaveData) this.printStatement();
      else if (isAltBres && doesItHaveData) this.$refs.commonActionRef.onBrowseBidClick();
      else if (isAltIres && doesItHaveData) this.printInfoSheet();
      else if (isAltAres || isAltPres || isAltSres || isAltIres || isAltBres) this.custumColrFlashMsg({ msg: 'Please select a record' });
    },
    async imagesLeftClick(leftClick) {
      if (this.isNewItem) {
        await this.$refs.crudList.$refs.crudDialog.apply();
        this.uploadFileClickParams.leftClickFlag = true;
        this.uploadFileClickParams.leftClickDef = leftClick;
      } else {
        leftClick();
      }
    },
    async imagesRightClick(rightClick) {
      if (this.isNewItem) {
        await this.$refs.crudList.$refs.crudDialog.apply();
        this.uploadFileClickParams.rightClickFlag = true;
        this.uploadFileClickParams.rightClickDef = rightClick;
      } else {
        rightClick();
      }
    },
    async printStatement() {
      const item = { ...this.selectedRowData };
      if (!item._id) {
        return;
      }
      const { jwt } = await this.reAuth();
      const penaltyDate = this.editedItem.penaltyDateValue
        || item.penaltyDateValue
        || this.criteriaState.penaltyDateValue;
      const params = [
        `token=${jwt}`,
        `wkst=${Number(this.wkstNumber)}`,
        `penaltyDate=${penaltyDate}`,
        `ids=${item._id}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/taxInquiry/pick-list/printStatement${queryString}`;
      if (this.taxSettingItem.addCommentOnStatementMailed) {
        this.pendingStatementUrl = url;
        this.showMailingDialog = true;
      } else {
        printerHandler(this, { url, reportName: 'taxStatements', deafultPrinterMode: true });
      }
    },
    confirmStatementMailed(isMailed) {
      this.showMailingDialog = false;
      if (!this.pendingStatementUrl) return;
      const url = isMailed
        ? `${this.pendingStatementUrl}&mailedStatement=1`
        : this.pendingStatementUrl;
      printerHandler(this, { url, reportName: 'taxStatements', deafultPrinterMode: true });
      this.pendingStatementUrl = null;
    },
    async printInfoSheet() {
      const item = { ...this.selectedRowData };
      if (!item._id) {
        return;
      }
      const { jwt } = await this.reAuth();

      const to = `taxInquiry/pick-list/printInfoSheet?ids=${item._id}&reportname'infosheet'&token=${jwt}&wkst=${Number(this.wkstNumber)}`;
      const toUrl = `${backendRest.defaults.baseURL}/${to}`;
      // window.open(toUrl);
      printerHandler(this, { url: toUrl, reportName: 'infoSheets', deafultPrinterMode: true });
    },
    getAuthToken() {
      return getRawJwt();
    },
    async handleEmail() {
      const itemData = this.item(this.baseCrudKey);
      const {
        bccEmailAddress, emailAdd, subjectBody, subjectLine, taxId, taxYear, penaltyDate,
        saveEmailToRecord,
      } = this.editEmailItem;

      const item = {
        email: emailAdd,
        bccEmailAddress,
        subject: subjectLine,
        subjectBody,
        saveEmailToRecord: !!saveEmailToRecord,
        taxYear: parseInt(taxYear, 10),
        taxId: parseInt(taxId, 10),
        ids: itemData._id,
        token: this.getAuthToken(),
        penaltyDate,
        wkstID: Number(this.wkstNumber),
      };
      this.sendMail({ item });
      // alert('handle email', item);
    },
  },
};
</script>
